import { Button, Panel, Separator, Text } from "@nju/ui";
import { formatPhoneNumber, POSITIVE_DIGITS } from "@nju/utils";

interface IMySimCardChangeNumberConfirmProps {
  isLoadingCancel: boolean;
  isLoadingCommit: boolean;
  selectedNumber: string;
  handleCommitOrder: () => void;
  handleCancelOrder: () => void;
}

export function MySimCardChangeNumberConfirm({
  isLoadingCommit,
  isLoadingCancel,
  selectedNumber,
  handleCommitOrder,
  handleCancelOrder,
}: IMySimCardChangeNumberConfirmProps) {
  return (
    <Panel testId="change-number-confirm-panel">
      <Text
        size={{
          "@onlyMobile": "xl",
          "@fromTablet": "keySM",
        }}
        weight="bold"
      >
        potwierdzenie zmiany
      </Text>
      <Separator size="xxs" tone="invisible" />
      <Text
        size={{
          "@fromTablet": "l",
          "@onlyMobile": "m",
        }}
        testId="client-number"
      >
        Czy na pewno chcesz zmienić swój numer telefonu na{" "}
        {formatPhoneNumber(selectedNumber, POSITIVE_DIGITS, " ", "", true)}?
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-between only-mobile:gap-3 only-mobile:flex-col-reverse flex-row">
        <Button
          isLoading={isLoadingCancel}
          onPress={handleCancelOrder}
          size={{ "@onlyMobile": "s" }}
          variant="secondary"
        >
          anuluj
        </Button>
        <Button
          isLoading={isLoadingCommit}
          onPress={handleCommitOrder}
          size={{ "@onlyMobile": "s" }}
        >
          tak, zmieniam
        </Button>
      </div>
    </Panel>
  );
}
